import React from "react";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

import DialogContent from "@mui/material/DialogContent";
import { useErrorReport } from "./processingDiscoveryServices";
import Container from "@mui/material/Container";
import PanelLoadingIndicator from "../../components/PanelLoadingIndicator";
import { capitalCase } from "change-case";
import { map, pipe, toPairs } from "ramda";
import { List, ListItem, ListItemText } from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const formatErrors = pipe(
  toPairs,
  map(([key, value]) => `${capitalCase(key)} ${value}`),
);

const ContentIngestionErrorsDialog = ({ errorFileLocation, open, onClose }) => {
  const {
    data: errorReport,
    isLoading: isLoading,
    isSuccess: isSuccess,
  } = useErrorReport(errorFileLocation);

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={open}
      onClose={onClose}
      aria-labelledby="Error Report"
    >
      <DialogTitle id="content-ingestion-error-dialog-title">
        Error Report
      </DialogTitle>
      <DialogContent>
        {isLoading && (
          <Container style={{ height: 400 }}>
            <PanelLoadingIndicator />
          </Container>
        )}

        {isSuccess && (
          <List>
            {map(
              error => (
                <ListItem key={error}>
                  <ListItemIcon>
                    <ErrorOutlineIcon fontSize="large" color="error" />
                  </ListItemIcon>
                  <ListItemText primary={error} />
                </ListItem>
              ),
              formatErrors(errorReport),
            )}
          </List>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContentIngestionErrorsDialog;
